/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceLocationPermission } from './DeviceLocationPermission';
import {
    DeviceLocationPermissionFromJSON,
    DeviceLocationPermissionFromJSONTyped,
    DeviceLocationPermissionToJSON,
    DeviceLocationPermissionToJSONTyped,
} from './DeviceLocationPermission';
import type { LocationPreference } from './LocationPreference';
import {
    LocationPreferenceFromJSON,
    LocationPreferenceFromJSONTyped,
    LocationPreferenceToJSON,
    LocationPreferenceToJSONTyped,
} from './LocationPreference';

/**
 * 
 * @export
 * @interface OrgUserOnAzure
 */
export interface OrgUserOnAzure {
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    pending_org_code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     */
    allow_location_tracking_while_compass_connected: boolean;
    /**
     * 
     * @type {LocationPreference}
     * @memberof OrgUserOnAzure
     */
    location_preference: LocationPreference;
    /**
     * 
     * @type {DeviceLocationPermission}
     * @memberof OrgUserOnAzure
     */
    device_location_permission?: DeviceLocationPermission;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    pvd_config_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    emergency_config_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     */
    should_force_apply_pvd_config: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     */
    should_force_apply_emergency_config: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    already_accepted_pvd_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    already_accepted_emergency_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    unified_config_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    should_force_apply_config: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    already_accepted_spec_etag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    language_code: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     */
    is_prototyper: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrgUserOnAzure
     */
    last_interaction_timestamp?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof OrgUserOnAzure
     */
    _ts: number;
    /**
     * 
     * @type {string}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    org_spec_azure_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    emergency_contact_auth_ids?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    always_include_in_emergencies: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserOnAzure
     * @deprecated
     */
    auto_add_contacts: boolean;
}



/**
 * Check if a given object implements the OrgUserOnAzure interface.
 */
export function instanceOfOrgUserOnAzure(value: object): value is OrgUserOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('phone_number' in value) || value['phone_number'] === undefined) return false;
    if (!('allow_location_tracking_while_compass_connected' in value) || value['allow_location_tracking_while_compass_connected'] === undefined) return false;
    if (!('location_preference' in value) || value['location_preference'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('pvd_config_id' in value) || value['pvd_config_id'] === undefined) return false;
    if (!('emergency_config_id' in value) || value['emergency_config_id'] === undefined) return false;
    if (!('should_force_apply_pvd_config' in value) || value['should_force_apply_pvd_config'] === undefined) return false;
    if (!('should_force_apply_emergency_config' in value) || value['should_force_apply_emergency_config'] === undefined) return false;
    if (!('unified_config_id' in value) || value['unified_config_id'] === undefined) return false;
    if (!('should_force_apply_config' in value) || value['should_force_apply_config'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    if (!('is_prototyper' in value) || value['is_prototyper'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    if (!('org_spec_azure_id' in value) || value['org_spec_azure_id'] === undefined) return false;
    if (!('always_include_in_emergencies' in value) || value['always_include_in_emergencies'] === undefined) return false;
    if (!('auto_add_contacts' in value) || value['auto_add_contacts'] === undefined) return false;
    return true;
}

export function OrgUserOnAzureFromJSON(json: any): OrgUserOnAzure {
    return OrgUserOnAzureFromJSONTyped(json, false);
}

export function OrgUserOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'phone_number': json['phone_number'],
        'pending_org_code': json['pending_org_code'] == null ? undefined : json['pending_org_code'],
        'allow_location_tracking_while_compass_connected': json['allow_location_tracking_while_compass_connected'],
        'location_preference': LocationPreferenceFromJSON(json['location_preference']),
        'device_location_permission': json['device_location_permission'] == null ? undefined : DeviceLocationPermissionFromJSON(json['device_location_permission']),
        'role': json['role'],
        'pvd_config_id': json['pvd_config_id'],
        'emergency_config_id': json['emergency_config_id'],
        'should_force_apply_pvd_config': json['should_force_apply_pvd_config'],
        'should_force_apply_emergency_config': json['should_force_apply_emergency_config'],
        'already_accepted_pvd_etag': json['already_accepted_pvd_etag'] == null ? undefined : json['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': json['already_accepted_emergency_etag'] == null ? undefined : json['already_accepted_emergency_etag'],
        'unified_config_id': json['unified_config_id'],
        'should_force_apply_config': json['should_force_apply_config'],
        'already_accepted_spec_etag': json['already_accepted_spec_etag'] == null ? undefined : json['already_accepted_spec_etag'],
        'language_code': json['language_code'],
        'is_prototyper': json['is_prototyper'],
        'last_interaction_timestamp': json['last_interaction_timestamp'] == null ? undefined : json['last_interaction_timestamp'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'org_spec_azure_id': json['org_spec_azure_id'],
        'emergency_contact_auth_ids': json['emergency_contact_auth_ids'] == null ? undefined : json['emergency_contact_auth_ids'],
        'always_include_in_emergencies': json['always_include_in_emergencies'],
        'auto_add_contacts': json['auto_add_contacts'],
    };
}

export function OrgUserOnAzureToJSON(json: any): OrgUserOnAzure {
    return OrgUserOnAzureToJSONTyped(json, false);
}

export function OrgUserOnAzureToJSONTyped(value?: OrgUserOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'phone_number': value['phone_number'],
        'pending_org_code': value['pending_org_code'],
        'allow_location_tracking_while_compass_connected': value['allow_location_tracking_while_compass_connected'],
        'location_preference': LocationPreferenceToJSON(value['location_preference']),
        'device_location_permission': DeviceLocationPermissionToJSON(value['device_location_permission']),
        'role': value['role'],
        'pvd_config_id': value['pvd_config_id'],
        'emergency_config_id': value['emergency_config_id'],
        'should_force_apply_pvd_config': value['should_force_apply_pvd_config'],
        'should_force_apply_emergency_config': value['should_force_apply_emergency_config'],
        'already_accepted_pvd_etag': value['already_accepted_pvd_etag'],
        'already_accepted_emergency_etag': value['already_accepted_emergency_etag'],
        'unified_config_id': value['unified_config_id'],
        'should_force_apply_config': value['should_force_apply_config'],
        'already_accepted_spec_etag': value['already_accepted_spec_etag'],
        'language_code': value['language_code'],
        'is_prototyper': value['is_prototyper'],
        'last_interaction_timestamp': value['last_interaction_timestamp'],
        'object_type': value['object_type'],
        'unique_key': value['unique_key'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
        'org_spec_azure_id': value['org_spec_azure_id'],
        'emergency_contact_auth_ids': value['emergency_contact_auth_ids'],
        'always_include_in_emergencies': value['always_include_in_emergencies'],
        'auto_add_contacts': value['auto_add_contacts'],
    };
}

